export default __webpack_public_path__ + "c8cbec009293555149b15132fed6c166.svg";